import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUsersSelectedCounter = createSelector(
  [(store: RootState) => store.formSubmittedSlice.selectedUsers],
  // Devuelve el listado de users seleccionados o asignados
  (data) => data.length
);
